import {InjectionToken} from '@angular/core';
import {LearningChannelType} from '../components/profile/LearningChannel';

export const CHANNEL_SERVICE = new InjectionToken<ChannelService>('ChannelService');

export interface ChannelService {
    channel: LearningChannelType;

    getChannel(): LearningChannelType;
    setChannel(channel: LearningChannelType): void;
}
